import { render, staticRenderFns } from "./ProductVendor.vue?vue&type=template&id=7185caa9&functional=true"
import script from "./ProductVendor.vue?vue&type=script&lang=js"
export * from "./ProductVendor.vue?vue&type=script&lang=js"
import style0 from "./ProductVendor.vue?vue&type=style&index=0&id=7185caa9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports